import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Waypoint from 'react-waypoint';

import Section from './Section';
import Tab from './Tab';

import { sectionType } from '../utils';

const Bar = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const BarInnerWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const BarPlaceholder = styled.div`
  height: ${p => (p.keepSpace ? `${p.theme.product.tabs.height}px` : 0)};
`;

const BarWrapper = styled.div`
  background-color: ${p => p.theme.product.tabs.background};
  left: 0;
  position: ${p => (p.fixed ? 'fixed' : 'relative')};
  right: 0;
  text-align: center;
  top: ${p => (p.fixed ? p.offset : 0)};
  z-index: 2;
`;

const Underline = styled.div`
  position: absolute;

  height: 3px;
  width: ${p => `${p.width}px`};

  bottom: 0;
  left: ${p => `${p.position}px`};

  background-color: ${p => p.theme.product.tabs.activeColor};
  transition: ${p =>
    p.ready
      ? `left ${p.theme.product.tabs.transitionSpeed}ms ease-in-out, width ${
        p.theme.product.tabs.transitionSpeed
      }ms ease-in-out`
      : 'none'};
`;

class Tabs extends React.Component {
  static propTypes = {
    offset: PropTypes.string,
    productSlug: PropTypes.string,
    sections: PropTypes.arrayOf(sectionType)
  };

  static defaultProps = {
    offset: '0',
    sections: []
  };

  state = {
    activeIndex: 0,
    fixed: false,
    isTransitioning: false,
    underline: {
      position: 0,
      ready: false,
      width: 0
    }
  };

  changeSection = id => {
    if (this.state.isTransitioning) return;
    const i = this.props.sections.findIndex(section => section.id === id);
    this.setState({ activeIndex: i });
  };

  checkBarPosition = ({ currentPosition: now, previousPosition: previous }) => {
    if (now === Waypoint.above) {
      this.setState({ fixed: true });
    }
    if (now === Waypoint.inside && previous === Waypoint.above) {
      this.setState({ fixed: false });
    }
  };

  handleScrollTransition = isTransitioning =>
    this.setState({ isTransitioning });

  moveUnderline = underline => this.setState({ underline });

  render() {
    const { offset, sections } = this.props;
    const { activeIndex, fixed, underline } = this.state;

    return (
      <React.Fragment>
        <Waypoint
          onPositionChange={this.checkBarPosition}
          topOffset={offset}
          scrollableAncestor="window"
        />
        <BarPlaceholder keepSpace={fixed} />
        <BarWrapper fixed={fixed} offset={offset}>
          <BarInnerWrapper>
            <Bar>
              {sections.map((section, i) => (
                <Tab
                  active={i === activeIndex}
                  key={section.id}
                  onActive={this.moveUnderline}
                  onClick={this.changeSection}
                  section={section}
                  transitionListener={this.handleScrollTransition}
                />
              ))}
            </Bar>
            <Underline {...underline} />
          </BarInnerWrapper>
        </BarWrapper>
        {sections.map(section => (
          <Section
            key={section.id}
            section={section}
            onEnter={this.changeSection}
            productSlug={this.props.productSlug}
          />
        ))}
      </React.Fragment>
    );
  }
}

export default Tabs;
